// extracted by mini-css-extract-plugin
export default {"step":"SignupContent_step__bz68j","back":"SignupContent_back__rDolt","ani":"SignupContent_ani__Q2vQE"};